import React from 'react'
import { Show, useTranslate } from 'react-admin'
import InvoiceLayout from '../invoices/InvoiceLayout'
import ReverseInvoiceShowActions from './ReverseInvoiceShowActions'

const ReverseInvoiceShow = () => {

  const translate = useTranslate()

  return (
    <Show actions={<ReverseInvoiceShowActions />} title={translate("resources.reverseInvoices.name", {smart_count: 1})}>
      <InvoiceLayout resource='reverseInvoices' isPreview={false} />
    </Show>
  )
}

export default ReverseInvoiceShow